<template>
  <div class="main-ct">
    <div class="header-ct">
      <p>{{ $t('InfinityAI_FAQ_Header') }}</p>
    </div>
    <div class="collapse-container">
      <el-collapse v-for="question in questions" :key="$t(question.question)">
        <el-collapse-item :title="$t(question.question)">
          <p v-html="$t(question.answer)"></p>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MLStudioFrequentlyAskedQuestions',
  data() {
    return {
      questions: [
        {
          question: 'InfinityAI_FAQ_WhatsDifferent_Question',
          answer: 'InfinityAI_FAQ_WhatsDifferent_Answer'
        },
        {
          question: 'InfinityAI_FAQ_Setup_Question',
          answer: 'InfinityAI_FAQ_Setup_Answer'
        },
        {
          question: 'InfinityAI_FAQ_Verticals_Question',
          answer: 'InfinityAI_FAQ_Verticals_Answer'
        },
        {
          question: 'InfinityAI_FAQ_PreviousExperience_Question',
          answer: 'InfinityAI_FAQ_PreviousExperience_Answer'
        },
        {
          question: 'InfinityAI_FAQ_Pricing_Question',
          answer: 'InfinityAI_FAQ_Pricing_Answer'
        },
        {
          question: 'InfinityAI_FAQ_XAI_Question',
          answer: 'InfinityAI_FAQ_XAI_Answer'
        }
      ]
    }
  }
}
</script>

<style scoped>
.main-ct {
  display: flex;
  flex-direction: column;
  padding: 60px 100px 120px 100px;
  gap: 15px;
}
.header-ct {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 20px;

  p {
    text-align: center;
    color: #5c6374;
    font-size: 24px;
    font-weight: 600;
    line-height: 30px;
  }
}

.collapse-container {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/deep/ .el-collapse {
  padding: 20px;
  background-color: #fff;
  border: none;
}

/deep/ .el-collapse-item__wrap {
  border-bottom: none;
}

/deep/ .el-collapse-item__header {
  color: #5c6374;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  border-bottom: none;
}

/deep/ .el-collapse-item__content {
  color: #7e8596;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/modules/ml-studio/components/MlStudioFrequentlyAskedQuestions.vue